import { Box, Container, Divider, Typography } from "@mui/material";
import React, { useCallback } from "react";
import Particles from "react-particles";
import { loadFull } from "tsparticles";
import Header from "../../Pages/Staking/Header";
import { NavLink } from "react-router-dom";

const data = [
  {
    title: "Home",
    path: "/",
  },

  {
    title: "White paper",
    path: "/whitepaper",
  },

  {
    title: "Dapp",
    path: "/staking",
  },
  {
    title: "Farming",
    path: "/farming",
  },
];
const NewHeroSection = () => {
  const particlesInit = useCallback(async (engine) => {
    await loadFull(engine);
  }, []);

  const particlesLoaded = useCallback(async (container) => {}, []);

  const particleOptions = {
    autoPlay: true,
    background: {
      color: {
        value: "transparent",
        opacity: "0.2",
      },
    },
    fpsLimit: 120,
    interactivity: {
      events: {
        onHover: {
          enable: true,
          mode: "grab",
        },
      },
      modes: {
        grab: {
          distance: 200,
          links: {
            opacity: 0.8,
          },
        },
      },
    },
    size: {
      // Replace this property with the new one
      value: 1, // Decrease the value to decrease particle size
      random: true, // Enable random size variation
      anim: {
        enable: false, // Disable size animation
        speed: 0, // Set animation speed to 0 (disabled)
        size_min: 0, // Set minimum size during animation
      },
    },

    particles: {
      number: {
        value: 200,
      },
      color: {
        value: "#a0c8f0",
      },
      shape: {
        type: "polygon",
        polygon: {
          sides: 15,
        },
      },
      move: {
        // Enable particle movement
        enable: true,
        // Set the speed of particles
        speed: 2,
        // Enable particles to bounce off the edges
        bounce: true,
      },

      size: {
        value: 1, // Decrease the value to decrease particle size
        random: true, // Enable random size variation
        anim: {
          enable: false, // Disable size animation
          speed: 0, // Set animation speed to 0 (disabled)
          size_min: 0, // Set minimum size during animation
        },
      },
    },

    responsive: [
      // Add this property after the particles object
      {
        maxWidth: 768, // Apply this configuration for screens smaller than 768px
        options: {
          particles: {
            number: {
              value: 100, // Reduce the number of particles to 100
            },
          },
          interactivity: {
            modes: {
              grab: {
                distance: 100, // Reduce the distance of the grab mode to 100
              },
            },
          },
        },
      },
    ],
  };

  return (
    <Box
      sx={{
        position: "relative",
        background: "#000",
        /* Additional styles for the container */
        width: "100%",
        minHeight: "100vh",
        height: "auto",
      }}
    >
      <Particles
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={particleOptions}
      />

      <Container>
        <Box
          sx={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0 }}
        >
          <Header />

          <Box
            display={"flex"}
            flexDirection={"column"}
            justifyContent={"space-between"}
            height={"75%"}
          >
            <Box mt={6} px={{ sm: 8, xs: 3 }}>
              <Typography
                sx={{
                  fontSize: "30px",
                  fontFamily: "Roboto Slab",
                  color: "#CA3A38",
                  fontWeight: "900",
                }}
              >
                Welcome to the DeFi Sage
                <Typography
                  component={"span"}
                  sx={{
                    fontSize: "20px",
                    fontFamily: "Roboto Slab",
                    color: "#fff",
                    fontWeight: "900",
                    ml: 0.3,
                  }}
                >
                  where decentralized finance meets limitless possibilities!
                </Typography>
              </Typography>

              <Typography
                sx={{
                  fontSize: "18px",
                  color: "#fff",
                  fontFamily: "Lato",
                  mt: 1,
                }}
              >
                To the future of finance, where trust is secured by the
                blockchain and financial freedom is within your reach.
              </Typography>
            </Box>

            <Box px={{ sm: 8, xs: 3 }} my={2}>
              <Divider sx={{ bgcolor: "gray" }} />
              <Box
                display="flex"
                justifyContent={"space-between"}
                mt={2}
                pl={2}
              >
                {data.map((item, i) => {
                  return (
                    <NavLink
                      to={item?.path}
                      style={{ textDecoration: "none", color: "white" }}
                      key={i}
                    >
                      <Typography
                        key={i}
                        className="rainfall-button"
                        sx={{
                          cursor: "pointer",
                          mt: 2,
                          textAlign: "left",
                          fontFamily: "Roboto Slab                ",
                          fontSize: "13px",
                          transition: "1s ease-in-out",
                          color: `#fff`,
                          "&:hover": {
                            transition: "1s ease-in-out",
                            color: `#E0115F`,
                          },
                        }}
                      >
                        {item?.title}
                      </Typography>
                    </NavLink>
                  );
                })}
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default NewHeroSection;
